// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Q7rq","col":"styles_col__2Qsp1","fulfillmentStatus":"styles_fulfillmentStatus__hnvHs","emailCol":"styles_emailCol__IGV4g"};